import React from "react";
import reactToString from "react-to-string";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

export const markdownToJSX = input => typeof input === "string" ?
    input.split(/\*\*/g).map((str, i) => i % 2 === 0 ? str : <b key={ i }>{ str }</b>) : null;

export const richTextToSimpleText = input => reactToString(documentToReactComponents(input));

export const truncateRichText = (input, length) => {
    const text = typeof input === "string" ? input : richTextToSimpleText(input);

    if (text.length <= length) {
        return text;
    }

    const cutText = text.substring(0, length);
    const lastSpace = cutText.lastIndexOf(" ");
    return cutText.substring(0, lastSpace) + "..."
};

export const formatDate = (utcDateString, locale) => {
    const date = new Date(utcDateString);

    return `${date.toLocaleDateString(locale, { month: "long", day: "numeric" })}, ${date.getFullYear()}`;
};

export const getLabelForDuration = (durationDays, translations) => {
    switch (durationDays) {
        case 8:
            return "1 " + ((translations && translations.week) ? translations.week : "week");
        case 15:
            return "2 " + ((translations && translations.weeks) ? translations.weeks : "weeks");
        case 22:
            return "3 " + ((translations && translations.weeks) ? translations.weeks : "weeks");
        default:
            if (durationDays === 1) {
                return "1 " + ((translations && translations.day) ? translations.day : "day");
            } else {
                return durationDays + " " + ((translations && translations.days) ? translations.days : "days");
            }
    }
};

export const getLabelForPersons = (numberOfPersons, translations) => {
    switch (numberOfPersons) {
        case 1:
            return "1 " + ((translations && translations.person) ? translations.person : "person");
        default:
            return numberOfPersons + " " + ((translations && translations.persons) ? translations.persons : "persons");
    }
};
